import React from "react";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";

const Nfl = () => {
    const navigate = useNavigate();
    return (
        <div >
            <div className="indicator-container">
                <div className="indicator ">

                </div>
                <div className="indicator ">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator selected">

                </div>
                <div className="indicator">

                </div>
            </div>

            <div className="vivify fadeIn duration-500" style={{
                marginTop: '5vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'

            }}>
                <img style={{ width: '100%' }} className="vivify fadeIn" src="/assets/nfl.png" alt="dad" />


                <h1 className="large-text"><CountUp prefix="You Spent " end={180} duration={5} /> Hours Watching Football (NFL)</h1>
                <div className="large-button-container">
                    <button onClick={
                        () => {
                            navigate('/dad/lowes');
                        }
                    } className="large-button">
                        Let's Continue
                    </button>
                </div>
            </div>

        </div>
    );
}

export default Nfl